import { NoData } from "../no-data/NoData"
import { Table, Button, Modal } from "react-bootstrap"
import { useState, useEffect, useMemo } from "react"
import { toast } from "react-toastify"
import courseApi from "../../apis/courseApi"
import CourseForm from "../course/CourseForm"
import { useDispatch, useSelector } from "react-redux"
import { fetchCoursesAction } from "../../pages/course/courseAction"

const CourseTable = () => {
  const [crs, setCrs] = useState([])
  const [courseData, setCourseData] = useState()
  const [show, setShow] = useState()
  const [showEdit, setShowEdit] = useState()
  const { user } = useSelector((state) => state.user)
  const { courses } = useSelector((state) => state.course)
  const dispatch = useDispatch()

  const params = useMemo(() => {
    const p = new URLSearchParams()
    p.set("branch", user?.branch)
    return p
  }, [user?.branch])

  useEffect(() => {
    dispatch(fetchCoursesAction(params.toString()))
  }, [dispatch, params])

  useEffect(() => {
    setCrs(courses)
  }, [courses])

  const handleDelete = async (_id) => {
    if (!_id) {
      return
    }
    if (window.confirm("Are you sure you want to delete this course?")) {
      try {
        const res = await courseApi.deleteACourse(_id)

        res && toast.success("Course deleted Successfully!")
        dispatch(fetchCoursesAction(params.toString()))
      } catch (error) {
        console.log(error)
      }
    }
  }

  const viewCourse = async (course) => {
    setShow(!show)
    setCourseData(course)
  }

  const editCourse = async (course) => {
    setShowEdit(true)
    setCourseData(course)
  }

  if (!crs?.length) {
    return (
      <>
        <NoData />
      </>
    )
  }
  return (
    <div>
      <Modal
        show={show}
        backdrop="static"
        animation={false}
        data={courseData}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Course Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <div className="">
              <h6>
                <b>Course Name:</b> {courseData?.title}
              </h6>
              <h6>
                <b>Course Code:</b> {courseData?.courseCode}
              </h6>
              <h6>
                <b>Course Location:</b>{" "}
                <span className="text-capitalize">{courseData?.location}</span>
              </h6>
              <h6>
                <b>Course Fee:</b> ${courseData?.courseFee}
              </h6>
              <h6>
                <b>Early Bird Discount:</b> ${courseData?.discount || "N/A"}
              </h6>
              <h6>
                <b>Course Duration:</b>{" "}
                {new Date(courseData?.commenceDate).toLocaleDateString()} -
                {new Date(courseData?.endDate).toLocaleDateString()}
              </h6>
            </div>
          </>
        </Modal.Body>
      </Modal>
      <Modal
        show={showEdit}
        backdrop="static"
        animation={false}
        data={courseData}
        onHide={() => setShowEdit(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Course Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CourseForm courseData={courseData} setShowEdit={setShowEdit} />
        </Modal.Body>
      </Modal>
      <div className="table-responsive">
        <Table striped bordered hover className="text-center">
          <thead>
            <tr>
              <th>#</th>
              <th>Status</th>
              <th>Course Name</th>
              <th>Course Code</th>
              <th>Location</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {crs.map((c, i) => (
              <tr key={c._id}>
                <td>{i + 1}</td>
                <td
                  className={
                    c.status === "active" ? "text-success" : "text-danger"
                  }
                >
                  {c.status.toUpperCase()}
                </td>
                <td>{c.title}</td>
                <td>{c.courseCode}</td>
                <td className="text-capitalize">{c.location}</td>
                <td className="d-flex justify-content-center gap-2">
                  <Button variant="info" onClick={() => viewCourse(c)}>
                    View
                  </Button>
                  <Button variant="warning" onClick={() => editCourse(c)}>
                    Edit
                  </Button>

                  <Button variant="danger" onClick={() => handleDelete(c._id)}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  )
}

export default CourseTable
